import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash-es';

@Component({
    selector: 'progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnInit {

    /**
     * Current active step
     * @type number
     * @memberof ProgressBarComponent
     */
    @Input() currentStep: number = 1;
    /**
     * Total number of stemp
     * @type number
     * @memberof ProgressBarComponent
     */
    @Input() totalSteps: number = 1;

    /**
     * Arrange to build the steps 1 .. totalSteps
     * @type number
     * @memberof ProgressBarComponent
     */
    range: number[];
    /**
     * Constructor
     * @memberof ProgressBarComponent
     */
    constructor() { }

    /**
     * Initialise the component
     * @memberof ProgressBarComponent
     */
    ngOnInit() {
        this.range = _.range(1, this.totalSteps + 1);
    }

}
